import React, { useState } from "react";
import { Table } from "antd";
import { Link } from "react-router-dom";
import moment from "moment";

const BusinessesTable = (props) => {
  const [expandedRowKeys, setExpandedRowKeys] = useState([]); // Track expanded row

  const columns = [
    {
      title: "Subscriber ID",
      dataIndex: "userId",
      key: "userId",
    },
    {
      title: "Company Name",
      dataIndex: "companyName",
      key: "companyName",
    },
    {
      title: "Registered Date",
      key: "createdAt",
      render: (record) => (
        <span>{moment(record.createdAt).format("DD-MM-YYYY")}</span>
      ),
    },
    {
      title: "Email Id",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Phone",
      dataIndex: "mobileNo",
      key: "mobileNo",
    },
  ];

  const handleExpand = (expanded, record) => {
    setExpandedRowKeys(expanded ? [record.id] : []); // Ensure only one row expands at a time
  };

  return (
    <Table
      columns={columns}
      dataSource={props.data}
      rowKey={(record) => record.id}
      pagination={!props.mini}
      expandable={{
        expandedRowRender: (record) => (
          <div style={{ paddingLeft: 24 }}>
            <p>Team Strength: {record.teamStrength || "N/A"}</p>
            <p>Company Location: {record.location || "N/A"}</p>
            <p>
              Company Start Date:{" "}
              {record.startDate
                ? moment(record.startDate).format("DD-MM-YYYY")
                : "No date"}
            </p>
            <p>GMB Profile URL: {record.gmbProfileUrl || "N/A"}</p>
          </div>
        ),
        rowExpandable: (record) => !!record.teamStrength, // Only expand if data exists
        expandedRowKeys,
        onExpand: handleExpand, // Control row expansion
      }}
      footer={() =>
        props.mini ? (
          <tr>
            <td colSpan={columns.length} style={{ textAlign: "center" }}>
              <Link to="/admin/businesses">View More</Link>
            </td>
          </tr>
        ) : null
      }
    />
  );
};

export default BusinessesTable;



// import { Table, Button, Modal, Row, Col } from 'antd';
// import { useState } from 'react';
// import { Link } from 'react-router-dom';
// import RaiseDuplicateModal from '../Modals/RaiseDuplicateModal';
// import moment from 'moment';

// const BusinessesTable = (props) => {
//   const [recordId, setRecordId] = useState(null);
//   const [modalVisible, setModalVisible] = useState(false);
//   const [confirmModalVisible, setConfirmModalVisible] = useState(false); // Add this line

//   const columns = [
//     {
//       title: 'Company Name',
//       dataIndex: 'companyName',
//       key: 'userId',
//     },
//     {
//       title: 'Registered Date',
//       key: 'userId',
//       render: (record) => (
//         <span>{moment(record.createdAt).format('DD-MM-YYYY')}</span>
//       ),
//     },
//     {
//       title: 'Email Id',
//       dataIndex: 'email',
//       key: 'userId',
//     },
//     {
//       title: 'Phone',
//       dataIndex: 'mobileNo',
//       key: 'userId',
//     },
//     // {
//     //   title: 'Action',
//     //   key: 'action',
//     //   render: (record) => (
//     //     <Button type="link" danger onClick={() => { setRecordId(record.id); setConfirmModalVisible(true) }}>
//     //       Block Business
//     //     </Button>
//     //   ),
//     // },
//   ];

//   const handleConfirm = () => {
//     // Add your code to block the business here
//     // For example, you can make an API call to update the business status in the database

//     setConfirmModalVisible(false);
//     setModalVisible(true);
//   };

//   return (
//     <div>
//       <Table
//         columns={columns}
//         dataSource={props.data}
//         key={record => record.id}
//         pagination={!props.mini}
//         expandable={props.expand ? {
//           expandedRowRender: (record) => (
//             <>
//              <div style={{display:'grid'}}>
//                 <span className="mb-2">Team strength : {record.teamStrength}</span>
//                 <span className="mb-2">Companay Location : {record.location}</span>
//                 <span className="mb-2">Companay Start date : {moment(record.startDate).format('DD-MM-YYYY') || 'no date'}</span>
//                 <span className="mb-2">GMB Profile url: {record.gmbProfileUrl}</span>
//               </div>
//             </>
//           ),
//         } : false}
//         footer={() => props.mini ? (
//           <tr>
//             <td colSpan={columns.length} style={{ textAlign: 'center' }}>
//               <Link to="/admin/businesses">View More</Link>
//             </td>
//           </tr>
//         ) : null}
//       />
//       {/* <Modal title="Block Business" visible={confirmModalVisible} onOk={handleConfirm}
//         onCancel={() => setConfirmModalVisible(false)}>
//         <p>Are you sure you want to block this business?</p>
//       </Modal> */}
//     </div>
//   );
// };

// export default BusinessesTable;